import _ from 'lodash'

import { bus, helper } from '../../utils'
import config from '../../config'
import Sidebar from '../Sidebar/Sidebar.vue'
import SolutionStatusTest from '../SolutionStatusTest/SolutionStatusTest.vue'
import routes from '../../routes'
import { i18n, loadLanguageAsync } from '@/i18n'

const ROOT_PATH = '/'

export default {
  components: { Sidebar, SolutionStatusTest },
  computed: {
    currentLang () {
      return this.languages[i18n.locale]
    },
    currentVersion () {
      return this.$t('dashFooterVersionText', [this.footer.version])
    },
    hasVersion () {
      const version = this.footer.version
      return !!(version)
    },
    isAnalyticsEnabled () {
      return this.analytics.enabled
    },
    username () {
      return this.$store.state.user
    }
  },
  methods: {
    checkValidToken () {
      return this.$api.checkToken()
        .catch((error) => {
          this.cleanData()
          if (error.status === 403) {
            this.$router.push('/login')
          } else {
            this.$router.push('/404')
          }
        })
    },
    cleanData () {
      return helper.clearLoginData(this)
    },
    getSolutionConfig () {
      return this.$api.getTheme()
        .then(({ body }) => {
          this.analytics.enabled = body.analytics_enabled
          this.footer.version = body.solution_version.replace(/-[\da-f]{7}$/, '')
          this.$store.commit('SET_DATA_RETENTION', body.data_retention || '31d')
        })
    },
    goToCompanyUrl () {
      const validPaths = this.getValidPaths()
      return this.$api.getTheme()
        .then(({ body }) => {
          const companyUrl = body && body.company_url
          if (companyUrl && !_.isEmpty(companyUrl) && this.$route.path === ROOT_PATH) {
            window.location.assign(companyUrl)
          } else if (this.$route.path !== ROOT_PATH && this.isValidPath(validPaths)) {
            this.checkValidToken()
          } else {
            this.$router.push('/404')
          }
        })
        .catch((e) => {
          this.$router.push('/404')
        })
    },
    handleCommand (command) {
      switch (command) {
        case 'signOut':
          return this.onSignOut()
        case 'solutionStatusTest':
          return this.onSolutionStatusTest()
        default:
          throw new Error('command is required.')
      }
    },
    isValidPath (validPaths) {
      let arr = []
      arr = validPaths.map((path) => {
        const regex = new RegExp(`/${path}(?:/(?=$))?`)
        return regex.test(this.$route.path)
      })
      return arr.some((key) => key)
    },
    getValidPaths (data = routes) {
      let validPaths = []
      for (const route of data) {
        const children = route.children
        const path = route.path

        if (path === '*') {
          continue
        }

        if (children) {
          validPaths = validPaths.concat(this.getValidPaths(children))
        } else if (path !== '/') {
          validPaths.push(path)
        }
      }

      return validPaths
    },
    onSignOut () {
      this.cleanData()
      this.$router.push('/login')
    },
    onSolutionStatusTest () {
      bus.$emit('show-solution-status-test', {
        show: true
      })
    }
  },
  name: 'Dash',
  created () {
    loadLanguageAsync()
    const token = this.$cookie.get('sid')
    if (!token) {
      this.loading = true
      return this.goToCompanyUrl()
    }

    this.getSolutionConfig()
    this.loading = false

    const validPaths = this.getValidPaths()
    if (this.isValidPath(validPaths)) {
      this.$router.push(this.$route.path)
    } else {
      this.$router.push('/device')
    }
  },
  data () {
    return {
      analytics: {
        enabled: false,
        href: '/analytics',
        target: '_blank',
        text: 'Analytics'
      },
      dropdown: {
        lang: {
          class: 'lang-dropdown',
          command: loadLanguageAsync,
          items: [{
            command: 'en',
            'data-qa': 'Header-LangDropdown-Item-EN',
            id: 'lang-en',
            text: 'English'
          },
          {
            command: 'zh',
            'data-qa': 'Header-LangDropdown-Item-zh',
            id: 'lang-zh',
            text: '中文'
          }],
          trigger: 'click'
        }
      },
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      footer: {
        copyRight: {
          text: 'dashFooterCopyRightText'
        },
        documentation: {
          href: 'https://exohome-docs.exosite.io/',
          target: '_blank',
          text: 'dashFooterDocumentationText'
        },
        exosite: {
          href: 'https://www.exosite.com',
          target: '_blank',
          text: 'Exosite'
        },
        privacy: {
          href: 'https://www.exosite.com/data-privacy-policy',
          text: 'dashFooterPrivacyText'
        },
        support: {
          href: 'https://support.exosite.com/hc/en-us/requests/new',
          text: 'dashFooterSupportText'
        },
        terms: {
          href: 'https://www.exosite.com/terms-conditions',
          text: 'dashFooterTermsText'
        },
        version: null
      },
      isCollapse: false,
      languages: {
        en: 'English',
        zh: '中文'
      },
      loading: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Dash/Dash.js